/* eslint-disable complexity */
import classNames from 'classnames';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import ReactCookies from 'react-cookies';
import { useDispatch, useSelector } from 'react-redux';
import COOKIES from '../../../../config/cookies/cookies';
import {
  LINK_CHECKOUT_BUTTON,
  LINK_MY_VOUCHERS,
  LINK_SECOND_CHECKOUT,
} from '../../../../config/links/links';
import {
  BUY_EXCL,
  BUYNOW_EXCL,
  BUYNOW,
  GIVE_AS_A_GIFT,
  ADD_TO_BASKET,
  CHOOSE_YOUR_OPTIONS_TEXT,
  VIEW_AVAILABILITY_TEXT,
} from '../../../../config/text/text';
import { trackEvent, updateDod } from '../../../../helpers/analytics';
import {
  basketCreator,
  mergeProducts,
} from '../../../../helpers/basketCreator';
import useCheckMobile from '../../../../helpers/checkMobile';
import {
  getIsChooseYourProductDeal,
  useIsExpressBuy,
} from '../../../../helpers/deals';
import errorTrackingService from '../../../../helpers/errorTrackingService';
import giftsExpressBuyService from '../../../../helpers/giftsExpressBuyService';
import { getBrowser, getOperatingSystem } from '../../../../helpers/payment';
import { scrollToProductPageDropDown } from '../../../../helpers/scroll';
import { getAddonsFromDealPosition } from '../../../../helpers/secondCheckout';
import { redirectToURL } from '../../../../helpers/url';
import { getIsEligibleForVip } from '../../../../helpers/vipSubscribeHelper';
import { getCurrencyWallet } from '../../../../helpers/wallet';
import PurchaseContext from '../../../../providers/PurchaseProvider';
import ThemeContext from '../../../../providers/ThemeProvider';
import { createBasket, fetchBasket } from '../../../../redux/actions/basket';
import { setLoadingState } from '../../../../redux/actions/loading';
import { LOADING_STATUS } from '../../../../redux/reducers/loading';
import { replaceBasket } from '../../../../services/basket';
import { logToSplunk } from '../../../_generic/axiosSplunk/axiosSplunk';
import PrimaryButton from '../../../_generic/button/PrimaryButton';
import ApplePayDealExpresssCheckout from '../../../applePayDealExpressCheckout';
import GooglePayDealExpressCheckout from '../../../googlePayDealExpressCheckout';
import DealChooseYourOptionsClaimMessage from './DealChooseYourOptionsClaimMessage';
import DealGiftButton from './DealGiftButton';

const DealBuyButton = ({
  buttonRef,
  deal = {},
  className = '',
  position = 0,
  text = null,
  isClaim = false,
  isSoldOut = false,
  buttonType = 'other',
  isTypeMobile = false,
  trackingEnabled,
  isOptionSelected = false,
  handleBuyButtonClick,
  isValidExternal,
  stickyButton = false,
  payDeposit = false,
  secondCheckout = false,
  selectedOptions,
  isProductPage = false,
  setShowEmptyMessage,
  columnSelection = 0,
  mapView = false,
  rowSelection = 0,
  isExpressDealPage = false,
  buyButton = null,
  paymentInstruments = null,
  isCheckReady = true,
  selection = null,
  deposit = false,
  setIsExpressPayLoaded,
  nibbleAppeared = false,
  // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  const router = useRouter();
  const locationStore = useSelector((state) => state.locations);
  const [userWallet, isAuthenticated] = useSelector((state) => [
    state.wallet.userWallet,
    state.user.isAuthenticated,
  ]);
  const dispatch = useDispatch();
  const userBalance = getCurrencyWallet(userWallet)
    ?.balanceWithValidExperienceCredit;
  const userVipStatus = useSelector(
    (state) => state.user.userprofile.userVipStatus,
  );
  const [disabled, setDisabled] = useState(false);
  const isMobile = useCheckMobile(false);
  const theme = useContext(ThemeContext);
  const [, setOrderId] = useContext(PurchaseContext);
  const os = getOperatingSystem();
  const browser = getBrowser();

  const showApplePay = (os === 'iOS' || os === 'macOS') && browser === 'Safari';
  const showGooglePay =
    os === 'Android' ||
    os === 'Windows' ||
    os === 'Linux' ||
    (browser === 'Chrome' && os === 'macOS') ||
    browser === 'Firefox';

  let sumWithInitial;
  if (position?.length > 0) {
    sumWithInitial = position?.reduce(
      (previousValue, currentValue, currentIndex) => {
        if (currentValue > 0) {
          return (
            previousValue + deal.products[currentIndex].price * currentValue
          );
        }

        return previousValue;
      },
      0,
    );
  }
  const oneClickCheckout = ReactCookies.load(COOKIES.oneClickCheckout);
  const orderSummary = {};
  const finalOrderAmount = deal?.price;
  const isGiftExpressBuyable = useIsExpressBuy(deal?.id, isAuthenticated)
    ?.giftClaimable;

  const isQuickBuy =
    userBalance > sumWithInitial && isClaim && isGiftExpressBuyable;

  const showExpressCheckoutStyles =
    ![CHOOSE_YOUR_OPTIONS_TEXT, VIEW_AVAILABILITY_TEXT].includes(buyButton) ||
    (buyButton === VIEW_AVAILABILITY_TEXT && isOptionSelected);

  const viewAvailExpressCheck =
    buyButton === VIEW_AVAILABILITY_TEXT && isOptionSelected;

  const marginBottomExpress =
    buyButton === VIEW_AVAILABILITY_TEXT
      ? isOptionSelected && nibbleAppeared
        ? '-15px'
        : !deal?.giftable
        ? '0px'
        : '-4px'
      : nibbleAppeared
      ? '-10px'
      : !deal?.giftable
      ? '0px'
      : '-4px';

  const expressBuyFailToCheckout = async () => {
    let products = basketCreator(deal, locationStore);

    const basketToken = ReactCookies.load(COOKIES.basketToken);
    const customerToken = ReactCookies.load(COOKIES.customerToken);
    const currentBasket = await fetchBasket(
      basketToken,
      customerToken,
      isAuthenticated,
    );

    if (currentBasket?.products) {
      // if there were products before, we merge them
      products = mergeProducts(currentBasket.products, products);
    }

    const btAux = basketToken
      ? await replaceBasket(
          basketToken,
          products,
          isAuthenticated,
          getIsEligibleForVip(isAuthenticated, userVipStatus),
        )
      : await createBasket(
          products,
          getIsEligibleForVip(isAuthenticated, userVipStatus),
        );

    if (!btAux && !basketToken) {
      errorTrackingService.logError({
        error: 'No Basket Token',
        message: 'Basket token cannot be undefined.',
      });
    }
    redirectToURL(`${LINK_CHECKOUT_BUTTON}/${btAux || basketToken}`, router);
  };

  const afterError = () => {
    console.log('encountered an error');
  };
  const expressBuySuccess = (orderId) => {
    dispatch(setLoadingState(LOADING_STATUS.READY));
    setOrderId(orderId);

    redirectToURL(`${LINK_SECOND_CHECKOUT}/benefits/${orderId}`, router);
  };

  const onClick = async () => {
    if (secondCheckout) {
      const addon = getAddonsFromDealPosition(deal, position);
      if (addon.length > 0) {
        trackEvent('buy-now-modal');
        handleBuyButtonClick(addon);
      }

      return;
    }
    if (mapView) {
      trackEvent('MV_buy_click');
    }
    const isChooseYourProductDeal = getIsChooseYourProductDeal(deal);

    if (
      isProductPage &&
      (rowSelection == 0 || columnSelection == 0) &&
      !isChooseYourProductDeal
    ) {
      setShowEmptyMessage(true);
      scrollToProductPageDropDown();

      return;
    }
    if (isProductPage && rowSelection == 0 && isChooseYourProductDeal) {
      setShowEmptyMessage(true);
      scrollToProductPageDropDown();

      return;
    }
    if (isValidExternal && isValidExternal() === false) return;
    setDisabled(true);
    if (trackingEnabled) {
      trackEvent('click_buy');
      updateDod({ clickBuyType: `click_buy_${buttonType}` });
    }

    const basketToken = ReactCookies.load(COOKIES.basketToken);
    const customerToken = ReactCookies.load(COOKIES.customerToken);
    const currentBasket = await fetchBasket(
      basketToken,
      customerToken,
      isAuthenticated,
    );

    let products = basketCreator(
      deal,
      locationStore,
      position,
      false,
      payDeposit,
    );

    // If deal is express buyable then add quick buy
    if (isQuickBuy) {
      giftsExpressBuyService.failToCheckout = expressBuyFailToCheckout;
      giftsExpressBuyService.success = expressBuySuccess;
      giftsExpressBuyService.setProgressTest = (message) =>
        dispatch(setLoadingState(LOADING_STATUS.LOADING, message));
      giftsExpressBuyService.products = products;
      giftsExpressBuyService.initMultiExpressBuy(deal, products);
    } else {
      if (currentBasket?.products) {
        // if there were products before, we merge them
        products = mergeProducts(currentBasket.products, products);
      }

      const newBasketToken = ReactCookies.load(COOKIES.basketToken);
      if (basketToken !== newBasketToken) {
        logToSplunk({
          bt: basketToken,
          ct: customerToken,
          description: 'Different basketTokens found from DealBuyButton',
          newBt: newBasketToken,
        });
      }
      const btAux =
        newBasketToken && newBasketToken?.length > 10
          ? await replaceBasket(
              newBasketToken,
              products,
              isAuthenticated,
              getIsEligibleForVip(isAuthenticated, userVipStatus),
            )
          : await createBasket(
              products,
              getIsEligibleForVip(isAuthenticated, userVipStatus),
            );
      redirectToURL(
        `${LINK_CHECKOUT_BUTTON}/${btAux || newBasketToken}`,
        router,
      );
    }
  };
  if (text) {
    return isExpressDealPage ? (
      <>
        <div className="general-button-container">
          <div className="first-button">
            <PrimaryButton
              aria-label={text}
              buttonRef={buttonRef}
              /* eslint-disable-next-line react/forbid-component-props */
              className={
                buyButton === VIEW_AVAILABILITY_TEXT && isOptionSelected
                  ? 'buy-button view-avail-express-btn common-express-style'
                  : className
              }
              disabled={disabled || isSoldOut}
              onClick={onClick}
            >
              {buyButton !== VIEW_AVAILABILITY_TEXT || viewAvailExpressCheck
                ? ADD_TO_BASKET
                : text}
            </PrimaryButton>
          </div>
          {buyButton !== VIEW_AVAILABILITY_TEXT &&
            paymentInstruments !== null &&
            showGooglePay && (
              <div className="second-button">
                <GooglePayDealExpressCheckout
                  afterError={afterError}
                  deal={deal}
                  finalOrderAmount={finalOrderAmount}
                  isAuthenticated={isAuthenticated}
                  isExpressDealPage={isExpressDealPage}
                  locationStore={locationStore}
                  noBottomText
                  oneClickCheckout={oneClickCheckout}
                  position={position}
                  selectedOptions={selectedOptions}
                  totalQuantity={1}
                />
              </div>
            )}
          {buyButton !== VIEW_AVAILABILITY_TEXT &&
            paymentInstruments !== null &&
            showApplePay && (
              <div className="second-button">
                <ApplePayDealExpresssCheckout
                  afterError={afterError}
                  deal={deal}
                  dealViewAvailability
                  finalOrderAmount={finalOrderAmount}
                  isAuthenticated={isAuthenticated}
                  isExpressDealPage={isExpressDealPage}
                  isMobile={isMobile}
                  isOptionSelected={isOptionSelected}
                  locationStore={locationStore}
                  noBottomText
                  oneClickCheckout={oneClickCheckout}
                  position={position}
                  selectedOptions={selectedOptions}
                  totalQuantity={1}
                />
              </div>
            )}

          {viewAvailExpressCheck &&
            paymentInstruments !== null &&
            showGooglePay && (
              <div className="second-button">
                <GooglePayDealExpressCheckout
                  afterError={afterError}
                  basketProducts={[]}
                  deal={deal}
                  dealViewAvailability
                  deposit={deposit}
                  finalOrderAmount={finalOrderAmount}
                  isAuthenticated={isAuthenticated}
                  isExpressDealPage={isExpressDealPage}
                  isOptionSelected={isOptionSelected}
                  noBottomText
                  oneClickCheckout={oneClickCheckout}
                  orderSummary={orderSummary}
                  selection={selection}
                  totalQuantity={1}
                />
              </div>
            )}
          {viewAvailExpressCheck &&
            paymentInstruments !== null &&
            showApplePay && (
              <div className="second-button">
                <ApplePayDealExpresssCheckout
                  afterError={afterError}
                  basketProducts={[]}
                  deal={deal}
                  dealViewAvailability
                  deposit={deposit}
                  finalOrderAmount={finalOrderAmount}
                  isAuthenticated={isAuthenticated}
                  isExpressDealPage={isExpressDealPage}
                  isMobile={isMobile}
                  isOptionSelected={isOptionSelected}
                  noBottomText
                  oneClickCheckout={oneClickCheckout}
                  orderSummary={orderSummary}
                  selection={selection}
                  totalQuantity={1}
                />
              </div>
            )}
        </div>

        {isClaim && selectedOptions?.length <= 1 && isMobile && (
          <DealChooseYourOptionsClaimMessage deal={deal} />
        )}
        <style jsx>{`
          .first-button {
            flex: 1;
          }
          .second-button {
            flex: 2;
          }
          .general-button-container {
            background-color: #ffffff;
            border-top: ${showExpressCheckoutStyles
              ? '1px solid #d3d3d3'
              : 'none'};
            display: flex;
            margin-bottom: ${marginBottomExpress};
            padding: ${showExpressCheckoutStyles ? '4px 0' : '0'};
          }
        `}</style>
      </>
    ) : (
      <>
        <PrimaryButton
          aria-label={text}
          buttonRef={buttonRef}
          /* eslint-disable-next-line react/forbid-component-props */
          className={className}
          disabled={disabled || isSoldOut}
          onClick={onClick}
        >
          {text}
        </PrimaryButton>
        {isClaim && selectedOptions?.length <= 1 && isMobile && (
          <DealChooseYourOptionsClaimMessage deal={deal} />
        )}
      </>
    );
  }

  if (text && !isMobile) {
    return (
      <>
        <PrimaryButton
          aria-label={text}
          buttonRef={buttonRef}
          /* eslint-disable-next-line react/forbid-component-props */
          className={className}
          disabled={disabled || isSoldOut}
          onClick={onClick}
        >
          {text}
        </PrimaryButton>
      </>
    );
  }

  return (
    <>
      {isMobile && !isCheckReady && (
        <div
          className={classNames('buy-button', {
            'hide-desktop': isTypeMobile,
            'maindeal-combined-button sticky-button': stickyButton,
          })}
        >
          {/* the span inside the button is only for GOOGLE purposes */}
          {isExpressDealPage ? (
            <div className="button-container">
              <div className="first-button">
                <PrimaryButton
                  aria-label={BUYNOW}
                  buttonRef={isOptionSelected ? null : buttonRef}
                  /* eslint-disable-next-line react/forbid-component-props */
                  className={classNames(
                    'choose-your-options-button',
                    className,
                  )}
                  disabled={disabled || isSoldOut}
                  id="choose-your-options"
                  onClick={onClick}
                >
                  {ADD_TO_BASKET}
                  <span style={{ display: 'none' }}>buy</span>
                </PrimaryButton>
              </div>
              {paymentInstruments !== null && showGooglePay && (
                <div className="second-button">
                  <GooglePayDealExpressCheckout
                    afterError={afterError}
                    deal={deal}
                    finalOrderAmount={finalOrderAmount}
                    isAuthenticated={isAuthenticated}
                    isExpressDealPage={isExpressDealPage}
                    isOptionSelected={isOptionSelected}
                    locationStore={locationStore}
                    noBottomText
                    oneClickCheckout={oneClickCheckout}
                    position={position}
                    selectedOptions={selectedOptions}
                    setIsExpressPayLoaded={setIsExpressPayLoaded}
                    totalQuantity={1}
                  />
                </div>
              )}
              {paymentInstruments !== null && showApplePay && (
                <div className="second-button">
                  <ApplePayDealExpresssCheckout
                    afterError={afterError}
                    deal={deal}
                    finalOrderAmount={finalOrderAmount}
                    isAuthenticated={isAuthenticated}
                    isExpressDealPage={isExpressDealPage}
                    isMobile={isMobile}
                    isOptionSelected={isOptionSelected}
                    locationStore={locationStore}
                    noBottomText
                    oneClickCheckout={oneClickCheckout}
                    position={position}
                    selectedOptions={selectedOptions}
                    totalQuantity={1}
                  />
                </div>
              )}
            </div>
          ) : (
            <PrimaryButton
              aria-label={BUYNOW}
              buttonRef={isOptionSelected ? null : buttonRef}
              /* eslint-disable-next-line react/forbid-component-props */
              className={classNames('choose-your-options-button', className)}
              disabled={disabled || isSoldOut}
              id="choose-your-options"
              onClick={onClick}
            >
              {BUYNOW}

              <span style={{ display: 'none' }}>buy</span>
            </PrimaryButton>
          )}
          {isProductPage && position < 0 && (
            <div className="gift-button">
              <PrimaryButton
                aria-label={GIVE_AS_A_GIFT}
                className="full-width outline margin"
                disabled={disabled || isSoldOut}
                onClick={onClick}
              >
                {GIVE_AS_A_GIFT}
              </PrimaryButton>
            </div>
          )}
          {isProductPage && position >= 0 && (
            <DealGiftButton
              className="full-width outline margin"
              columnSelection={columnSelection}
              deal={deal}
              isProductPage={isProductPage}
              isSoldOut={disabled || isSoldOut}
              position={position}
              rowSelection={rowSelection}
              setShowEmptyMessage={setShowEmptyMessage}
            />
          )}
        </div>
      )}

      {!isMobile && (
        <>
          <PrimaryButton
            aria-label={BUY_EXCL}
            buttonRef={buttonRef}
            /* eslint-disable-next-line react/forbid-component-props */
            className={className}
            disabled={disabled || isSoldOut}
            onClick={onClick}
          >
            {isMobile ? BUYNOW_EXCL : BUY_EXCL}
          </PrimaryButton>
          {isProductPage && position < 0 && (
            <div className="gift-button">
              <PrimaryButton
                aria-label={GIVE_AS_A_GIFT}
                className="full-width outline margin"
                disabled={disabled || isSoldOut}
                onClick={onClick}
              >
                {GIVE_AS_A_GIFT}
              </PrimaryButton>
            </div>
          )}
          {isProductPage && position >= 0 && (
            <DealGiftButton
              className="full-width outline margin"
              columnSelection={columnSelection}
              deal={deal}
              isProductPage={isProductPage}
              isSoldOut={isSoldOut}
              position={position}
              rowSelection={rowSelection}
              setShowEmptyMessage={setShowEmptyMessage}
            />
          )}
        </>
      )}
      <style jsx>{`
        .first-button {
          flex: 1;
        }
        .second-button {
          flex: 2;
        }
        .button-container {
          background-color: #ffffff;
          display: flex;
          margin-bottom: ${nibbleAppeared
            ? '-10px'
            : !deal?.giftable
            ? '8px'
            : '-4px'};
          border-top: 1px solid #d3d3d3;
          padding: 4px 0;
        }
        :global(.cat-main-deal .cat-main-deal__header-buttons .gift-button) {
          display: none;
        }
        :global(.choose-your-options .custom-select__select) {
          font-size: 20px;
        }
        :global(.primary-button.gifting) {
          color: ${theme.colors.primary} !important;
          background-color: #ffffff;
          border: 3px solid ${theme.colors.primary} !important;
          width: 75%;
          margin-left: 15%;
          transform: translate(-5%, -80%);
          margin-bottom: 0px;
          font-weight: bold;
        }
      `}</style>
    </>
  );
};

DealBuyButton.propTypes = {
  buttonRef: PropTypes.object,
  buttonType: PropTypes.string,
  className: PropTypes.string,
  columnSelection: PropTypes.number,
  deal: PropTypes.object,
  handleBuyButtonClick: PropTypes.func,
  isClaim: PropTypes.bool,
  isOptionSelected: PropTypes.bool,
  isProductPage: PropTypes.bool,
  isSoldOut: PropTypes.bool,
  isTypeMobile: PropTypes.bool,
  isValidExternal: PropTypes.func,
  mapView: PropTypes.bool,
  payDeposit: PropTypes.bool,
  position: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
  rowSelection: PropTypes.number,
  secondCheckout: PropTypes.bool,
  selectedOptions: PropTypes.array,
  setShowEmptyMessage: PropTypes.func,
  stickyButton: PropTypes.bool,
  text: PropTypes.string,
  trackingEnabled: PropTypes.bool,
};

DealBuyButton.defaultProps = {
  trackingEnabled: true,
};

export default DealBuyButton;
